/*eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { groupBy } from 'lodash';

// Third Party Components
import {
  GoogleMap,
  OverlayView,
  withScriptjs,
  withGoogleMap,
} from 'react-google-maps';

import MarkerClusterer from 'react-google-maps/lib/components/addons/MarkerClusterer';

// Components
import GeneralMarker from './GeneralMarker';
import MapTimer from './MapTimer';
import DeliveryModal from './DeliveryModal';
import LoadingIndicator from '../../../../../../components/LoadingIndicator';
import AlertMessage from '../../../../../../components/AlertMessage';

// util
import { performanceStatus } from '../../../../../Tracking/utils/delivery-status';

// thunks
import { getNfListLocation } from '../../../../../../redux/dashboard-real-time';

// selectors
import {
  getDashboardRealTimeUI,
  getDeliveryStatusDeliveriesByAccType,
} from '../../../../../../redux/selectors';

// css
import './styles.css';
import { getDeliveryStatusDeliveriesList, storeKeys } from '../../../../../../redux/delivery-status';
import { offsetCenter } from '../../../../../../utils/offsetCoodinates';

class DashboardRealTimeMap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      truckPositions: [],
    };

    this.googleMap = React.createRef();
  }

  componentDidMount() {
    this._requestMapData();
  }

  componentWillReceiveProps(newProps) {
    const { hideMarkerTooltip } = this.props;
    // If component has a new active tab or nfList is updated,
    // fetch location using those props
    if (this.props.deliveryStatusActiveTab !== newProps.deliveryStatusActiveTab) {
      this.props.dispatch(getNfListLocation(newProps.deliveryStatusActiveTab, newProps.nfList));

      hideMarkerTooltip();
    }
  }

  _requestMapData = async () => {
    // Make a new request
    const data = await this.props.dispatch(getDeliveryStatusDeliveriesList(false, storeKeys.REAL_TIME, !!this.props.notPassCompanyId));
    await this.props.dispatch(getNfListLocation(this.props.deliveryStatusActiveTab, data, () => this.props.getPositionFromTracking(this.googleMap.current)));
  }

  _setTruckPositions = () => {
    this.setState({ truckPositions: this._getNfListByActivePerformanceStatusCode() });
  }

  _getNfListByActivePerformanceStatusCode = () => {
    const { deliveryStatusActiveTab } = this.props;

    let locationList;

    if (deliveryStatusActiveTab === performanceStatus.LATE) locationList = this.props.lateLocationData;
    if (deliveryStatusActiveTab === performanceStatus.LATE_RISK) locationList = this.props.lateRiskLocationData;
    if (deliveryStatusActiveTab === performanceStatus.ONTIME) locationList = this.props.onTimeLocationData;

    let locationByPlate = groupBy(locationList, 'cd_Placa');
    const nfListGroup = groupBy(this.props.nfList, 'tms.plate');

    locationByPlate = Object.keys(locationByPlate).map((key, index) => {
      const loc = {
        ...locationByPlate[key][0],
        nfList: nfListGroup[key],
        isKeyAccount: this.props.nfList[index] ? this.props.nfList[index].tms.deliveryImportant : false,
        performanceStatusCode: this.props.nfList[index] ? this.props.nfList[index].tms.performanceStatus : 1,
      };
      delete loc.nfId;
      return loc;
    });

    return locationByPlate;
  }

  _renderActivePerformanceStatusCodeClassModifier = () => {
    const { deliveryStatusActiveTab } = this.props;

    if (deliveryStatusActiveTab === performanceStatus.LATE) {
      return '--late';
    }

    if (deliveryStatusActiveTab === performanceStatus.LATE_RISK) {
      return '--late-risk';
    }

    if (deliveryStatusActiveTab === performanceStatus.ONTIME) {
      return '--ontime';
    }

    return '';
  }

  _onUpdateTimer = () => {
    this.props.dispatch(getNfListLocation(this.props.deliveryStatusActiveTab, this.props.nfList));
  }

  _onRetry = () => {
    this.props.dispatch(getNfListLocation(this.props.deliveryStatusActiveTab, this.props.nfList));
  }


  render() {
    const {
      ui, mapCenter, renderMarkerTooltip, activeNf, hideMarkerTooltip, deliveryStatusActiveTab, zoom,
    } = this.props;

    return (
      <div>
        {/* ============================= */}
        {/* Map                           */}
        {/* ============================= */}
        <GoogleMap
          ref={this.googleMap}
          defaultZoom={zoom}
          defaultCenter={{ lat: -14.238962, lng: -51.913029 }} // Brazil
          onZoomChanged={hideMarkerTooltip}
          defaultOptions={{
            fullscreenControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            gestureHandling: 'cooperative',
          }}
          {...(mapCenter ? {
            center: {
              lat: mapCenter.lat,
              lng: mapCenter.lng,
            },
          } : {})}
          zoom={zoom}
        >
          {/* ============================= */}
          {/* Marker                        */}
          {/* ============================= */}
          <MarkerClusterer
            clusterClass={
              `DashboardRealTimeMap__cluster
              DashboardRealTimeMap__cluster${this._renderActivePerformanceStatusCodeClassModifier()}`
            }
            averageCenter
            enableRetinaIcons
            gridSize={30}
            minimumClusterSize={3}
          >
            {this._getNfListByActivePerformanceStatusCode().map((location, index) => (
              <GeneralMarker
                key={Number(index)}
                position={{ lat: location.iipoS_Latitude, lng: location.iipoS_Longitude }}
                keyAccount={location.isKeyAccount ? location.isKeyAccount : false} // TO DO remover ternarios depois de ajuste na API
                shippingGroupId={location.shippingGroupId}
                performanceStatusCode={deliveryStatusActiveTab}
                isActive={location.nfList && location.nfList.find(el => el.id === activeNf.nfId)}

                onClick={(e) => {
                  if (!activeNf.isVisible) {
                    const newCenter = offsetCenter(e.latLng, 180, -250, this.googleMap.current);
                    renderMarkerTooltip(e, location, newCenter);
                  } else {
                    hideMarkerTooltip();
                  }
                }}
              />
            ))}
          </MarkerClusterer>

          {/* ============================= */}
          {/* NFTooltip                     */}
          {/* ============================= */}
          {
            (activeNf && activeNf.isVisible) &&
            <OverlayView
              position={{
                lat: activeNf.lat, lng: activeNf.lng,
              }}
              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            >
              <DeliveryModal
                nfData={activeNf.data}
                initialSlide={activeNf.expanded}
                onClose={hideMarkerTooltip}
              />
            </OverlayView>
          }

        </GoogleMap>

        {/* ============================= */}
        {/* Loading Indicator             */}
        {/* ============================= */}
        {
          ui.isFetching &&
          <div className="DashboardRealTimeMap__loading-indicator">
            <LoadingIndicator theme="dark" />
          </div>
        }

        {/* ============================= */}
        {/* Error                         */}
        {/* ============================= */}
        {
          !ui.isFetching &&
          ui.error &&
          <div className="DashboardRealTimeMap__error-message">
            <AlertMessage
              error
              message="Ocorreu um erro ao carregar a posição dos veículos"
              actionText="Tente novamente"
              onRetry={() => this._onRetry()}
            />
          </div>
        }

        {/* ============================= */}
        {/* Map Timer                     */}
        {/* ============================= */}
        {
          !ui.isFetching &&
          !ui.error &&
          <div className="DashboardRealTimeMap__map-timer">
            <MapTimer
              onUpdate={this._onUpdateTimer}
              totalTime={1000 * 60 * 5}
            />
          </div>
        }


      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const isKeyAcc = null;

  return {
    lateLocationData: state.dashboardRealTime.late.data,
    lateRiskLocationData: state.dashboardRealTime.lateRisk.data,
    onTimeLocationData: state.dashboardRealTime.onTime.data,
    ui: getDashboardRealTimeUI(state),
    nfList: getDeliveryStatusDeliveriesByAccType(isKeyAcc, ownProps.deliveryStatusActiveTab, storeKeys.REAL_TIME)(state),
  };
}

export default connect(mapStateToProps)(withScriptjs(withGoogleMap(DashboardRealTimeMap)));
